import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/common/components/base.component';
import { ButtonTriggerEvent } from 'src/app/common/components/button/button.component';

@Component({
    templateUrl: './confirm.modal.component.html',
    styleUrls: ['./confirm.modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ConfirmModalComponent extends BaseComponent {

    public data: ConfirmModalData;
    public actions: ConfirmModalActions;
    public isChecked = false;
    @ViewChild('confirmCheckbox') confirmCheckbox: ElementRef;

    constructor(
        private dialogRef: MatDialogRef<ConfirmModalComponent>,
        private renderer: Renderer2,
        @Inject(MAT_DIALOG_DATA)
        data: any) {
        super();

        this.data = Object.assign({ confirmModalIcon: 'Exclaim_mk' }, data.data);
        this.actions = Object.assign({}, data.actions);
    }

    public close(): void {
        if (this.actions.cancel) {
            this.actions.cancel();
        }

        this.dialogRef.close();
    }

    public confirm(event: ButtonTriggerEvent) {
        if (this.data.confirmCheckboxDescription && !this.isChecked) {
            event.immediateComplete();

            // shake the confirm checkbox
            this.renderer.addClass(this.confirmCheckbox.nativeElement, 'ig-shake');
            setTimeout(() => {
                this.renderer.removeClass(this.confirmCheckbox.nativeElement, 'ig-shake');
            }, 500);
            return;
        }
        if (this.data.isAsync) {
            let oldFunc = event.complete;
            event.complete = () => {
                oldFunc();

                this.dialogRef.close();
            };

            this.actions.confirm(event);
        } else {
            this.actions.confirm(event);
            this.dialogRef.close();
        }
    }
}

export class ConfirmModalActions {
    confirm: (event: ButtonTriggerEvent) => void;
    cancel?: () => void;
}

export class ConfirmModalData {
    confirmModalIcon?: string;
    confirmModalTitle?: string;
    confirmModalDescription?: string;
    confirmModalConfirmButtonText?: string;
    confirmModalCancelButtonText?: string;
    isAsync?: boolean;
    color?: string;
    confirmCheckboxDescription?: string;
}
